__turbopack_context__.v({
  "className": "dm_serif_display_2cab2523-module__0RhqyG__className",
});
